import { useProductTier } from './useClientConfig'

/**
 * True on a Union-tier instance. Fails OPEN (returns true) until /api/config resolves —
 * consistent with useProductTier's Union default and visibleModules(). The single sanctioned
 * tier-boolean read; do not re-derive `productTier === 'Union'` elsewhere.
 */
export function useIsUnionTier(): boolean {
  return useProductTier() === 'Union'
}
